module.exports = __webpack_public_path__ + "static/media/hiw19.0d177f48.svg";